module.exports = __webpack_public_path__ + "static/media/40.837bfc56.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/40.png
// module id = 545
// module chunks = 0